import { Typography, RadioGroup, FormControlLabel, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox, Box } from "@mui/material";
import { useState } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { TiposVisualizacaoProposta } from "../../acoes/visualizarProposta/ModalVisualizarProposta";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";

interface TipoPropostaModalProps {
  onConfirm: (tipoProposta: TiposVisualizacaoProposta) => void 
  isOpened: boolean;
  close: () => void;
}

export function TipoPropostaModal({ onConfirm, close, isOpened }: TipoPropostaModalProps){
  const [tipoProposta, setTipoProposta] = useState<TiposVisualizacaoProposta | "">("")

  const permissoes = PermissionUtil.getPermissions();

  return (
    <Dialog
        open={isOpened}
        onClose={close}
      >
        <DialogTitle>
          <Typography variant="h6" color="textPrimary">
            Tipo de proposta
          </Typography>
        </DialogTitle>

        <DialogContent
          style={{ minWidth: "300px" }}
        >
          <DialogContentText>
            <RadioGroup
              row
              style={{ marginTop: "16px" } }
              value={tipoProposta}
              onChange={(event: any) => {
                const value = event.target.value as TiposVisualizacaoProposta
                setTipoProposta(value)
              }}
              aria-label="tipo-proposta"
              name="tipo-proposta"
              defaultValue={tipoProposta}>
                <FormControlLabel
                  value={'simplificada'}
                  control={<Radio color="primary" />}
                  label={'Proposta simplificada'}
                />
                <FormControlLabel
                  value={'detalhada'}
                  control={<Radio color="primary" />}
                  label={'Proposta detalhada'}
                />
            </RadioGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <FlatButton
            variant="outlined"
            onClick={close}
            color="secondary"
            text={"Cancelar"}
          />
          <FlatButton
            onClick={() => {
              if (tipoProposta) {
                onConfirm(tipoProposta);
              }
            }}
            color="primary"
            variant="contained"
            text={"Confirmar"}
          />
        </DialogActions>
      </Dialog>
  )
}